import React, { useState, useEffect } from 'react';
import Modal from "react-bootstrap/Modal";
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import {
  ModalContent,
  Card,
  TextQuantity,
  ButtonOutline
} from './styles';
import { InfoButton } from '~/components/layout/Buttons';

const RedirectToInitial = ({ modalRedirect, setModalRedirect }) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setModalRedirect(modalOpen);
  }, [modalOpen]);

  useEffect(() => {
    setModalOpen(modalRedirect);
  }, [modalRedirect]);

  function handleModal() {
    setModalRedirect(!modalRedirect);
  }

  function handlePath() {
    history.push('/criar-pedido');
  }

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        handleModal()
      }}
      centered={true}
    >
      <Modal.Body>
        <ModalContent>
          <>
            <Card>
              <Row>
                <Col>
                  <TextQuantity style={{ color: '#000FFF', marginBottom: '0.5rem' }}>Ao retornar à tela inicial, as reposições e descontos selecionados serão cancelados, e será necessário aplicá-los novamente durante o pedido.</TextQuantity>
                </Col>
              </Row>
            </Card>
            <Row>
              <Col>
                <TextQuantity style={{ marginBottom: '1rem', marginTop: '0.5rem' }} >Deseja continuar? </TextQuantity>
              </Col>
            </Row>
            <Row>
              <Col>
                <InfoButton onClick={() => handleModal()} style={{ marginTop: '0.5rem' }} >
                  <div>Cancelar</div>
                </InfoButton>
              </Col>
              <Col>
                < ButtonOutline outline onClick={() => handlePath()} style={{ marginTop: '0.5rem' }}>
                  <div>Continuar</div>
                </ButtonOutline>
              </Col>
            </Row>
          </>
        </ModalContent>
      </Modal.Body>
    </Modal>
  );
};

export default RedirectToInitial;
